import CryptoJS from 'crypto-js';

export const encryptData = (data: object, privateKey: string): string => {
  const strData = JSON.stringify(data);
  // return CryptoJS.AES.encrypt(strData, privateKey).toString();
  const passphrase1 = '44564';
  const passphrase2 = '17456';
  const passphrase3 = '15444';

  const getKeyFromPassPhrase = (passArr: string[]): string => {
    //key ve iv 16 karakter olmalı
    //backendde Int32 sınırı nedeniyle Int64 kullanıldı, burada Number olduğunda farklı sonuç veriyor. O nedenle BigInt olarak değiştirildi
    return `${(BigInt(passArr.join('')) >> BigInt(6)) << BigInt(9)}`;
  };

  return CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(strData),
    CryptoJS.enc.Utf8.parse(privateKey),
    {
      iv: CryptoJS.enc.Utf8.parse(getKeyFromPassPhrase([passphrase3, passphrase1, passphrase2])),
      keySize: 128 / 8,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
};

export const decryptData = (encryptedData: string): object => {
  const decryptedStr = CryptoJS.AES.decrypt(encryptedData, privateKey).toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedStr);
};

const privateKey = 'Ouuuv!';